import React from 'react';
import Card from './Card';
import Button from './Button';
import '../assets/styles.css'
import { useChat } from '../state/ChatProvider';

const CloseConfirm = () => {
    const { setShowCloseConfirm, endChat, toggleWidget, setIsChatOpen, isChatOpen, setChatEndedMessage} = useChat();

    const handleBackToChat = async () => {
        setShowCloseConfirm(false);
    }

    const handleClose = async () => {
        await endChat();
        toggleWidget();
        setIsChatOpen(!isChatOpen);
        setShowCloseConfirm(false);
        setChatEndedMessage("");
    }

    return (
        <Card>
            <div className='_kanis_card_title'>Close this conversation?</div>
            <div className='_kanis_card_subtitle'>Shutting this window will end the conversation. You can start a new conversation at any time.</div>
            <div style={{ display: 'flex', gap: '8px' }}>
                <Button type='primary' onClick={handleClose}>Close</Button>
                <Button type='outline' onClick={handleBackToChat}>Back to chat</Button>
            </div>
        </Card>
    );
}

export default CloseConfirm;

